import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import Theme from '../../Theme';
import * as Ant from 'antd';
import {useOutlet} from 'reconnect.js';
import Breadcrumb from '../../Components/Breadcrumb';

const pageSize = 20;
const pageRoute = '/profile/member-fee/';
const collectionName = 'member_fee';

function ProfileJobRequest(props) {
  const [user] = useOutlet('user');
  const [paging, setPaging] = React.useState({offset: 0, limit: pageSize});
  const [fetchResp, setFetchResp] = React.useState(null);

  const fetchDocumentList = React.useCallback(async () => {
    AppActions.setLoading(true);
    try {
      const extraQuery = {id_card_number: user.data?.id_card_number};
      const resp = await JStorage.fetchDocuments(
        collectionName,
        extraQuery,
        ['-year'],
        paging,
      );

      setFetchResp(resp);
    } catch (ex) {
      console.warn(ex);
    }
    AppActions.setLoading(false);
  }, [paging, user]);

  React.useEffect(() => {
    fetchDocumentList();
  }, [fetchDocumentList]);

  return (
    <Wrapper>
      <div className="tda-header">
        <h2>會費繳納紀錄</h2>
        <Breadcrumb />
      </div>

      <Ant.Table
        columns={[
          {
            title: '年度',
            key: 'year',
            dataIndex: 'year',
          },
          {
            title: '金額',
            key: 'amount',
            render: (_, record) => {
              return <div>NT${record.amount}</div>;
            },
          },
          {
            title: '狀態',
            key: 'payment',
            render: (_, record) => {
              return record.status === 'true' ? '已繳' : '未繳納';
            },
          },
          {
            title: '繳費日期',
            key: 'payment_date',
            dataIndex: 'payment_date',
          },
          {
            title: '收據編號',
            key: 'receipt_number',
            dataIndex: 'receipt_number',
          },
        ]}
        dataSource={fetchResp?.results}
        rowKey={'id'}
        pagination={{
          size: 'small',
          total: fetchResp?.total || 0,
          showSizeChanger: false,
          showTotal: (total) => `共 ${total} 筆, 每頁 ${pageSize} 筆`,
          current: paging.offset / pageSize + 1,
          pageSize: pageSize,
          position: ['bottomCenter'],
          onChange: (page, pageSize) => {
            if (pageSize) {
              setPaging({
                offset: (page - 1) * pageSize,
                limit: pageSize,
              });
            }
          },
        }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div``;

export default withPageEntry(ProfileJobRequest);
